import * as actionTypes from '../action-types';
import { appStateReducer } from './app-state-reducer';
import { IState } from '../types';

export const initialState: IState = {
  token: null,
  clientId: null,
  clientSecret: null,
  date: null,
  deviceType: null,
  doEnableScaling: false,
  equipmentType: null,
  featureFlags: {},
  language: null,
  overlay: false,
  softwareNumber: null,
  userId: null,
  userType: 'anonymous',
  platform: null,
  error: null,
  webviewError: null,
  webviewErrorMsg: null,
  baseGatewayAPIUrl: null,
  useMetricUnits: null,
  isEmbedded: null,
  appVersion: null,
  rawPayload: null,
  supportsDeepLinksV1: true,
};

export default (state: IState = initialState, action = undefined): IState => {
  switch (action?.type) {
    case actionTypes.DEVICE_TYPE:
      return { ...state, deviceType: action.value };
    case actionTypes.EQUIPMENT_TYPE:
      return { ...state, equipmentType: action.value };
    case actionTypes.DASHBOARD_ERROR:
      return { ...state, error: action.value };
    case actionTypes.WEBVIEW_ERROR:
      return { ...state, webviewError: action.value };
    case actionTypes.WEBVIEW_ERROR_MSG:
      return { ...state, webviewErrorMsg: action.value };
    case actionTypes.PLATFORM:
      return { ...state, platform: action.value };
    case actionTypes.APP_STATE:
      return appStateReducer(state, action);
    default:
      return state;
  }
};
